import {postMethod} from "./CommonFunctions"
const BASE_URL = 'api/ActionHistory';

export async function search(data)
{
  const result = await postMethod(`${BASE_URL}/Search`,data,"ACTION_HISTORY_SEARCH");
  return result;
}